import axios from "axios";
import { parse } from "papaparse";

export const getNotifications = async (user, userId, setLoading) => {
  setLoading(true);
  try {
    const postBody = { userId };
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/v2/notifications/getByUserId`,
      postBody,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    setLoading(false);
    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    setLoading(false);
    return [];
  }
};

export const getS3Data = async (user, s3Key, limit = 5, offset = 0) => {
  if (!s3Key) {
    throw new Error("S3 key is required");
  }

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/v2/notifications/bulk-signal/proxy`,
      {
        s3Key,
        limit,
        offset,
      },
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        }
      }
    );
    
    console.log("S3 data response:", response.data);

    return {
      data: response.data.data.map(item => ({
        ...item,
        coordinates: [parseFloat(item.LONGITUDE), parseFloat(item.LATITUDE)]
      })),
      hasMore: response.data.hasMore,
      total: response.data.totalCount,
      stats: response.data.stats,
      pagination: {
        offset,
        limit,
        total: response.data.totalCount,
      }
    };

  } catch (error) {
    console.error("Error fetching S3 data:", error);
    throw error;
  }
};

export default getNotifications;
